;(function() {
    const baseToggle = (target, fn = () => {}) => {
        let button = target.closest('[data-tggl-button]')
        if (!button) return
        
        let hideClass = button.getAttribute('data-tggl-button') || 'hide'
        let parent = button.closest('[data-tggl-parent]')
        if (!parent) return
        
        let items = parent.querySelectorAll('[data-tggl-item]')
        let item = button.closest('[data-tggl-item]')
        if (!item) return
        
        for (let i = 0; i < items.length; i++) {
            const el = items[i]
            let wrap = el.querySelector('[data-tggl-wrap]') 
            let list = el.querySelector('[data-tggl-list]')
            let height = wrap ? wrap.clientHeight : -1
            if (height >= 0 && list) {
                list.style.height = height + 'px'
            }
            
        }
        const resetHeight = () => {
            for (let i = 0; i < items.length; i++) {
                const el = items[i]
                let list = el.querySelector('[data-tggl-list]')
                list.style.height = null
            }
        }
        setTimeout(fn, 16, { button, hideClass, parent, items, item, resetHeight })
    }

    const toggleAllHide = ({ target }) => {
        baseToggle(target, ({ items, item, hideClass, resetHeight }) => {
            item.classList.toggle(hideClass)
            for (let i = 0; i < items.length; i++) {
                const el = items[i]
                if (el !== item) {
                    el.classList.add(hideClass)
                }
            }
            setTimeout(resetHeight, 300)
        })
    }

    const toggle = ({ target }) => {
        baseToggle(target, ({ item, hideClass, resetHeight }) => {
            item.classList.toggle(hideClass)
            setTimeout(resetHeight, 300)
        })
    }

    const update = ({ target }) => {
        baseToggle(target, ({ resetHeight }) => {
            resetHeight()
        })
    }

    window['accord'] = { toggleAllHide, toggle, update }
})()